import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const CholesterolPage = lazy(() => import("./CholesterolPage"));

const CholesterolPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <CholesterolPage />
    </Suspense>
  );
};

export default CholesterolPageLazy;
